import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { CreateEditAgendaItemForm, ICreateEditAgendaItemFormState } from ".";
import { useEffect } from "react";
import { MeetingAgendaItemType, MeetingType } from "../constants";

interface Props {
  visible: boolean;
  defaultValues?: ICreateEditAgendaItemFormState;
  meetingType: MeetingType;
  onSubmit: (data: ICreateEditAgendaItemFormState) => void;
  onCancel: () => void;
}

const EditAgendaItemModal = (props: Props) => {
  const { formState, control, handleSubmit, reset } = useForm<ICreateEditAgendaItemFormState>({
    defaultValues: {
      name: props.defaultValues?.name ?? "",
      description: props.defaultValues?.description ?? "",
      type: props.defaultValues?.type ?? MeetingAgendaItemType.Blank,
      allocatedTimeInMinutes: props.defaultValues?.allocatedTimeInMinutes ?? 0,
    },
  });

  useEffect(() => {
    if (props.visible) {
      reset({
        name: props.defaultValues?.name ?? "",
        description: props.defaultValues?.description ?? "",
        type: props.defaultValues?.type ?? MeetingAgendaItemType.Blank,
        allocatedTimeInMinutes: props.defaultValues?.allocatedTimeInMinutes ?? 0,
      });
    }
  }, [props.visible, props.defaultValues, reset]);

  function handleClose(_: object, reason: string) {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    props.onCancel();
  }

  async function handleDoneClicked() {
    handleSubmit((data) => {
      props.onSubmit({ ...data });
    })();
  }

  function handleCancelClicked() {
    reset(undefined, { keepDefaultValues: true });
    props.onCancel();
  }

  return (
    <Dialog open={props.visible} onClose={handleClose} fullWidth>
      <DialogTitle>Meeting Step</DialogTitle>
      <DialogContent>
        <CreateEditAgendaItemForm formState={formState} control={control} meetingType={props.meetingType} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCancelClicked}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleDoneClicked}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { EditAgendaItemModal };
